import { usePermissions } from "components/context/permissionsContext";

export const useDashboardPermission = () => {
  const { userPermissions } = usePermissions();

  // Shift Management
  const hasShiftGetPermission = userPermissions.some(
    (item) =>
      item.module === "Dashboard" &&
      item.controller === "ShiftTimeLog" &&
      item.identifier === "shifttimelog-get" &&
      item.hasPermission
  );
  const hasShiftSavePermission = userPermissions.some(
    (item) =>
      item.module === "Dashboard" &&
      item.controller === "ShiftTimeLog" &&
      item.identifier === "shifttimelog-save" &&
      item.hasPermission
  );
  const hasShiftDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Dashboard" &&
      item.controller === "ShiftTimeLog" &&
      item.identifier === "shifttimelog-delete" &&
      item.hasPermission
  );

  // Shift With Break
  const hasShiftWithBreakGetPermission = userPermissions.some(
    (item) =>
      item.module === "Dashboard" &&
      item.controller === "ShiftTimeLog" &&
      item.identifier === "shifttimelog-getshifttimelogswithbreaks" &&
      item.hasPermission
  );

  // Breaks
  const hasBreakGetPermission = userPermissions.some(
    (item) =>
      item.module === "Dashboard" &&
      item.controller === "ShiftTimeLog" &&
      item.identifier === "shifttimelog-getbreaks" &&
      item.hasPermission
  );
  const hasBreakSavePermission = userPermissions.some(
    (item) =>
      item.module === "Dashboard" &&
      item.controller === "ShiftTimeLog" &&
      item.identifier === "shifttimelog-savebreak" &&
      item.hasPermission
  );
  const hasBreakDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Dashboard" &&
      item.controller === "ShiftTimeLog" &&
      item.identifier === "shifttimelog-deletebreak" &&
      item.hasPermission
  );

  // To-Do
  const hasToDoGetPermission = userPermissions.some(
    (item) =>
      item.module === "Dashboard" &&
      item.controller === "ToDo" &&
      item.identifier === "todo-get" &&
      item.hasPermission
  );
  const hasToDoSavePermission = userPermissions.some(
    (item) =>
      item.module === "Dashboard" &&
      item.controller === "ToDo" &&
      item.identifier === "todo-save" &&
      item.hasPermission
  );
  const hasToDoDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Dashboard" &&
      item.controller === "ToDo" &&
      item.identifier === "todo-delete" &&
      item.hasPermission
  );

  // Tour
  const hasTourGetPermission = userPermissions.some(
    (item) =>
      item.module === "Dashboard" &&
      item.controller === "Tour" &&
      item.identifier === "companysettings-getfirstlogin" &&
      item.hasPermission
  );
  const hasTourSavePermission = userPermissions.some(
    (item) =>
      item.module === "Dashboard" &&
      item.controller === "Tour" &&
      item.identifier === "companysettings-savefirstlogin" &&
      item.hasPermission
  );

  // Scorecard
  const hasScorecardGetPermission= userPermissions.some(
    (item) =>
      item.module === "Dashboard" &&
      item.controller === "Scorecard" &&
      item.identifier === "scorecard-get" &&
      item.hasPermission
  );
  
  const DashboardPermissionProps = {
    // Shift Management
    hasShiftGetPermission,
    hasShiftSavePermission,
    hasShiftDeletePermission,

    // Shift With Break
    hasShiftWithBreakGetPermission,

    // Breaks
    hasBreakGetPermission,
    hasBreakSavePermission,
    hasBreakDeletePermission,

    // To-Do
    hasToDoGetPermission,
    hasToDoSavePermission,
    hasToDoDeletePermission,

    // Tour
    hasTourGetPermission,
    hasTourSavePermission,

    // Scorecard
    hasScorecardGetPermission
  };

  return {
    DashboardPermissionProps
  };
};
